"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePersistedState = void 0;
var react_1 = require("react");
/**
 * This hook works like a normal use state, but it will use the key to persist the data on the localstorage and use that data on the next reload
 * **It's only meant to be used with objects and arrays**
 * @param key The key that is going to be used to persist on localstorage
 * @param initialState  State thas is going to be used as initial render (If persisted data does not exist)
 * @param comparator Optional function to determine if data is equal, in that case it is not going to be persisted
 * @returns The state and setState struct
 * @example
 * const [user, setUsers] = usePersistedState("USERS", []) //Persist on every data change
 * //OR
 * const [assigments, setAssigments] = usePersistedState(
 *   'ASSIGMENTS',
 *   [],
 *   (prev, next) => prev.length === next.length //Only persist the data if the lenghts are different
 * );
 */
var usePersistedState = function (key, initialState, comparator) {
    var _a = (0, react_1.useState)(initialState), data = _a[0], setData = _a[1];
    var prevState = (0, react_1.useRef)(initialState);
    (0, react_1.useEffect)(function () {
        var persisted = localStorage.getItem(key);
        if (!persisted)
            return;
        var parsed = JSON.parse(persisted);
        prevState.current = parsed;
        setData(parsed);
    }, [key]);
    (0, react_1.useEffect)(function () {
        if (comparator === null || comparator === void 0 ? void 0 : comparator(prevState.current, data))
            return;
        prevState.current = data;
        localStorage.setItem(key, JSON.stringify(data));
    }, [comparator, data, key]);
    return [data, setData];
};
exports.usePersistedState = usePersistedState;
exports.default = usePersistedState;
